<template>
    <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary" style="width: 280px; height: 100vh;">
        <img style="max-width: 200px;" class="mb-3" src="@/images/logo.png" />
        <div class="usr">
            <h6>Olá <b>{{ usuario.name }}</b>  </h6>
        </div>
    <hr>
    <ul class="nav nav-pills flex-column mb-auto">
  <li class="nav-item">
    <RouterLink to="/dashboard" :class="`nav-link ${rotas.fullPath === '/dashboard' ? 'active' : false}`" aria-current="page">
      <i class="fa-thin fa-house-blank"></i>
      <span>Página Inicial</span>
    </RouterLink>
  </li>
  <li>
    <RouterLink to="/dados" :class="`nav-link ${rotas.fullPath === '/dados' ? 'active' : false}`">
      <i class="fa-thin fa-chart-pie"></i>
      <span>Dados</span>
    </RouterLink>
  </li>
  <li class="nav-item" @click="toggleSubmenu" :class="{ 'active': isSubmenuOpen }">
    <a style="cursor: pointer;" class="nav-link">
      <i class="fa-thin fa-chart-simple"></i>
      <span>Gráficos</span>
    </a>
    <ul v-if="isSubmenuOpen" class="nav flex-column ms-3">
      <li>
        <RouterLink to="/grafico" :class="`nav-link ${rotas.fullPath === '/grafico' ? 'active' : false}`">
          <span>Relatório 1</span>
        </RouterLink>
      </li>
      <!-- <li>
        <RouterLink to="/grafico2" :class="`nav-link ${rotas.fullPath === '/grafico2' ? 'active' : false}`">
          <span>Gráfico 2</span>
        </RouterLink>
      </li> -->
      <!-- Adicione mais submenus de gráficos conforme necessário -->
    </ul>
  </li>

<!--  <li>
    <RouterLink to="/usuario" :class="`nav-link ${rotas.fullPath === '/usuario' ? 'active' : false}`">
      <i class="fa-thin fa-user"></i>
      <span>Usuários</span>
    </RouterLink>
  </li> -->
  <li>
    <RouterLink to="/" :class="`nav-link ${rotas.fullPath === '/' ? 'active' : false}`">
      <i class="fa-light fa-right-from-bracket"></i>
      <span>Sair</span>
    </RouterLink>
  </li>
</ul>

    <div style="position: absolute; bottom:30px;">
        Powered by <b>Júnior</b>
    </div>
  </div>
</template>
<script setup>
import { RouterLink } from 'vue-router';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const rotas = ref(route)
const isSubmenuOpen = ref(false)

const toggleSubmenu  = () => {
    isSubmenuOpen.value = !isSubmenuOpen.value; // Alterna o estado do submenu
  }


const usuario = JSON.parse(localStorage.getItem('usuario'))
</script>

<style>

ul li a:hover {background:#93806A; color:#fff !important; }
ul li a { color:rgba(0,0,0,.8) !important}

.active { background-color: #93806A !important; color:#fff !important; font-weight: bolder !important;}
ul li  { margin-top: 10px; }
ul li a span { position: relative; left:10px;}
.usr { margin:0 auto}

</style>
